import { createBrowserRouter, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Board from "../../scenes/board/Board";
import JobBoard from "../../scenes/board/job-board/JobBoard";
import AppliedJobs from "../../scenes/board/job-board/tabs/applied-jobs/AppliedJobs";
import DraftsTimeline from "../../scenes/board/job-board/tabs/drafts/DraftsTimeline";
import JobPage from "../../scenes/board/job-board/tabs/job-timeline/JobPage";
import JobTimeline from "../../scenes/board/job-board/tabs/job-timeline/JobTimeline";
import MyJobs from "../../scenes/board/job-board/tabs/my-jobs/MyJobs";
import SavedJobs from "../../scenes/board/job-board/tabs/saved-jobs/SavedJobs";
import PostTimeline from "../../scenes/board/timelines/PostTimeline";
import CreateJob from "../../scenes/create-job/CreateJob";
import CreateTeam from "../../scenes/create-team/CreateTeam";
import Chat from "../../scenes/messages/chat/Chat";
import Messages, { EmptyChat } from "../../scenes/messages/Messages";
import PaymentFailed from "../../scenes/payment-result/PaymentFailed";
import PaymentSuccess from "../../scenes/payment-result/PaymentSuccess";
import PostPage from "../../scenes/post-page/PostPage";
import ProfileResolver from "../../scenes/profile-page/ProfileResolver";
import Settings from "../../scenes/settings/Settings";
import Success from "../../scenes/SignUp/Success/Success";
import SubscriptionPlans from "../../scenes/subscription-plans/SubscriptionPlans";
import TeamPage from "../../scenes/team-page/TeamPage";
import AuthRouteComponent from "./AuthRouteComponent";
import { selectUser } from "../auth/authSlice";
import { User } from "../../shared/models";

const MyJobsRedirect = () => {
	const user = useSelector(selectUser) as User;
	return <Navigate to={`/jobs/my-jobs/posted/${user?.userId}`} replace />;
};

const router = createBrowserRouter([
	{
		path: "/",
		element: <AuthRouteComponent />,
		children: [
			{
				index: true,
				element: <Navigate to="/board" />,
			},

			{
				path: "board",
				element: <Board />,
				children: [
					{
						index: true,
						element: <PostTimeline />,
					},
				],
			},

			{
				path: "messages",
				element: <Board />,
				children: [
					{
						element: <Messages />,
						children: [
							{
								index: true,
								element: <EmptyChat />,
							},
							{
								path: "new/:memberId",
								element: <Chat />,
							},
							{
								path: ":chatId",
								element: <Chat />,
							},
						],
					},
				],
			},

			{
				path: "jobs",
				element: <Board />,
				children: [
					{
						element: <JobBoard />,
						children: [
							{
								index: true,
								element: <JobTimeline />,
							},
							{
								path: "view/:jobId",
								element: <JobTimeline />,
								children: [{ index: true, element: <JobPage /> }],
							},
							{
								path: "my-jobs/posted/:userId",
								element: <MyJobs />,
							},
							{
								path: "my-jobs/saved/:userId",
								element: <SavedJobs />,
							},
							{
								path: "my-jobs/drafts/:userId",
								element: <DraftsTimeline />,
							},
							{
								path: "my-jobs/applied/:userId",
								element: <AppliedJobs />,
							},
							{
								path: "my-jobs/:userId",
								element: <MyJobsRedirect />,
							},
						],
					},
				],
			},

			{
				path: "create-job/:draft_id?",
				element: <Board />,
				children: [
					{
						index: true,
						element: <CreateJob />,
					},
				],
			},

			{
				path: "u/:userId",
				element: <ProfileResolver />,
				children: [
					{
						path: "success",
						element: <Success isProfile={true} />,
					},
				],
			},

			{
				path: "t/:teamId",
				element: <TeamPage />,
			},

			{
				path: "*",
				element: <Navigate to="/board" />,
			},

			{
				path: "p/:postId",
				element: <Board />,
				children: [
					{
						index: true,
						element: <PostPage />,
					},
				],
			},
			{
				path: "a/:jobId",
				element: <Board />,
				children: [
					{
						index: true,
						element: <JobPage />,
					},
				],
			},

			{
				path: "team/create",
				element: <CreateTeam />,
			},

			{
				path: "subscription",
				element: <Board />,
				children: [
					{
						index: true,
						element: <SubscriptionPlans />,
					},
				],
			},

			{
				path: "settings",
				element: <Board />,
				children: [
					{
						index: true,
						element: <Settings />,
					},
				],
			},

			{
				path: "payment-success",
				element: <PaymentSuccess />,
			},

			{
				path: "payment-failed",
				element: <PaymentFailed />,
			},
		],
	},
]);

export default router;
